import { centerDesAvocatsRoutes } from "./center-des-avocats-routes";

export default (router: any) => {
  centerDesAvocatsRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
